export const searchOptions = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Numeric Discord ID", value: "discord_id" },
  { label: "CF Handle", value: "verifiedCodeforcesHandle" },
  { label: "Institution Name", value: "miscDetails.institutionName" }
];
